<script setup lang="ts">
    import type { Component, HTMLAttributes } from 'vue';
    import AlertDescription from './AlertDescription.vue';
    import AlertRoot from './AlertRoot.vue';
    import AlertTitle from './AlertTitle.vue';
    import { type AlertVariants } from '.';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
        variant?: AlertVariants['variant'];
        icon?: Component | null;
        title?: string;
        description?: string;
    }>();
</script>

<template>
    <AlertRoot v-bind="props">
        <AlertTitle v-if="$slots.default || title">
            <slot>{{ title }}</slot>
        </AlertTitle>
        <AlertDescription>
            <slot name="description">{{ description }}</slot>
        </AlertDescription>
    </AlertRoot>
</template>
